import React from 'react';

import { getRewrittenUrl } from '../../../../../analytics-library/getRewrittenUrl';
import { ClickType } from '../../../../../sharedModules/getClickType';
import { LegacyEventType } from '../../../../../types/LegacyEventType';
import type { SeasonalEventMerchant } from '../../../../types/SeasonalEvent';
import { useHawkWidgetContext } from '../../HawkWidget/HawkWidgetProviderContext';
import { TargetEnum } from '../../TrackedLink/model';

import styles from './styles/seasonal-event-merchant.css';

interface SeasonalEventMerchantComponentProps {
  merchant: SeasonalEventMerchant;
  className?: string;
}

const SeasonalEventMerchantComponent: React.FC<SeasonalEventMerchantComponentProps> = ({
  merchant,
  className,
}): JSX.Element => {
  const linkRef = React.useRef<HTMLAnchorElement | null>(null);
  const {
    site,
    area,
    trackingArea,
    articleName,
    articleUrl,
    sendAnalytics,
    genericSharedComponents: { LazyImage, TrackedLink },
    social,
  } = useHawkWidgetContext();

  const getUrl = (customTrackingId: string): { url: string } => {
    return {
      url: getRewrittenUrl({
        url: merchant.merchant_url,
        site,
        customTrackingId,
        area,
        trackingArea,
        articleUrl,
        articleName,
        social,
      }),
    };
  };

  const trackLinkClick = (): void => {
    const { url } = getUrl(merchant.customTrackingId || '');
    sendAnalytics({
      event: {
        label: merchant.merchant_name,
        clickType: ClickType.SEASONAL_EVENT_RETAILER,
        type: LegacyEventType.CLICK_FROM,
      },
      product: {
        url,
        customTrackingId: merchant.customTrackingId,
        merchant: {
          id: merchant.merchant_id,
          name: merchant.merchant_name,
          url: merchant.merchant_url,
        },
      },
    });
  };

  const containerStyle = className && styles[className] ? className : 'container';

  return (
    <div className={styles[containerStyle]}>
      <TrackedLink
        trackLinkClick={trackLinkClick}
        customTarget={TargetEnum.BLANK}
        attributes={{
          ref: linkRef,
          className: styles['link'],
          href: getUrl(merchant.customTrackingId || '').url,
        }}
      >
        <div className={styles['image-container']}>
          <LazyImage src={merchant.logo} alt={merchant.merchant_name} width={100} height={50} />
        </div>
      </TrackedLink>
    </div>
  );
};

export default SeasonalEventMerchantComponent;
